<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="请求ID">
              <global-select
                v-model="queryParams.requestId"
                requestApi="/scp/scpConcurrentRequests/requestsIdBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称">
              <global-select
                v-model="queryParams.planName"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 1 }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划类型">
              <global-select
                :value.sync="queryParams.planType"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_PLAN_TYPES' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="提交人">
              <global-select
                v-model="queryParams.createBy"
                requestApi="/system/user/allJobCodeName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="阶段">
              <global-select
                :value.sync="queryParams.phaseList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SYS_REQUEST_PHASE' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.statusList"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SYS_REQUEST_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="实际开始时间" :labelCol="{ style: { width: '90px' } }">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.actualStartDate) }}</template>
                <a-range-picker
                  v-model="queryParams.actualStartDate"
                  valueFormat="YYYY/MM/DD HH:mm:ss"
                  :show-time="{ defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="实际完成时间" :labelCol="{ style: { width: '90px' } }">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.actualCompletionDate) }}</template>
                <a-range-picker
                  v-model="queryParams.actualCompletionDate"
                  :show-time="{ defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                  valueFormat="YYYY/MM/DD HH:mm:ss"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="提交时间">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.createByDate) }}</template>
                <a-range-picker
                  v-model="queryParams.createByDate"
                  :show-time="{ defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                  valueFormat="YYYY/MM/DD HH:mm:ss"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 2500 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.CALL_MATERIAL_PLAN_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a :disabled="!(record.phase === 'PENDING' || record.phase === 'RUNNING')" @click="gameOver(record)">终止运行</a>
                <a class="ml10" @click="$refs.dailyRecordModal.show(record, true)">查看运行日志</a>
              </span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <daily-record-modal ref="dailyRecordModal" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiScpConcurrentRequestsList, apiScpMrpPlansAbortPlan } from '@/api/scp/factoryCallMaterial/call-material-plan-list'
import { generateLsTableResData } from '@/utils/util.js';
import DailyRecordModal from '@/components/DailyRecordModal/index'

export default {
  // eslint-disable-next-line
  name: 'Call-material-plan-list', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DailyRecordModal
  },
  data () {
    return {
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpConcurrentRequestsList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询
      queryParams: {
        requestId: undefined,
        planName: undefined,
        planType: undefined,
        createBy: undefined,
        phaseList: undefined,
        statusList: undefined,
        actualStartDate: undefined,
        actualCompletionDate: undefined,
        createByDate: undefined
      },
      // 表格字段
      columns: [
        {
          title: '请求Id',
          dataIndex: 'requestId',
          align: 'center'
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          align: 'center'
        },
        {
          title: '计划类型',
          dataIndex: 'planTypeName',
          align: 'center'
        },
        {
          title: '主计划版本',
          dataIndex: 'scheduleVersion',
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          align: 'center'
        },
        {
          title: '计划运行时间',
          dataIndex: 'requestedStartDate',
          align: 'center',
          width: 170
        },
        {
          title: '阶段',
          dataIndex: 'phaseName',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center'
        },
        {
          title: '运行说明',
          dataIndex: 'completionComments',
          align: 'center',
          ellipsis: true
        },
        {
          title: '实际开始时间',
          dataIndex: 'actualStartDate',
          align: 'center',
          width: 170
        },
        {
          title: '实际完成时间',
          dataIndex: 'actualCompletionDate',
          align: 'center',
          width: 170
        },
        {
          title: '提交人',
          dataIndex: 'createName',
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 170
        },
        {
          title: '运行方式',
          dataIndex: 'resubmitTypeName',
          align: 'center'
        },
        {
          title: '运行时间间隔',
          dataIndex: 'runTimeInterval',
          align: 'center'
        },
        {
          title: '操作',
          width: 180,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created () {
    this.queryParams.planType = this.$route.query && this.$route.query.planType || ""
    this.queryParams.planName = this.$route.query && this.$route.query.planName || ""
    const arr = []
    const now = new Date();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    arr.push(`${this.$moment(yesterday).format('YYYY-MM-DD')} 00:00:00`)
    arr.push(`${this.$moment(now).format('YYYY-MM-DD')} 23:59:59`)
    this.queryParams.createByDate = arr
  },
  mounted () {
    this.handleQuery()
  },
  methods: {
    // 强制终止
    gameOver (record) {
      const self = this
      this.$confirm({
        title: '此操作将终止该计划所有定时或运行中的请求，请确认是否需要终止？',
        content: `注：如果需要仅取消某个请求，请从【计划请求列表】中查询取消。`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpMrpPlansAbortPlan({ planName: record.planName, requestId: record.requestId }).then((response) => {
            if (response.code === 200) {
              self.$message.success('强制终止成功!')
              self.handleQuery()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 表单搜索
    onSearch () {
      const { actualStartDate, actualCompletionDate, createByDate } = this.queryParams
      this.queryParams.startActualStartDate = actualStartDate && actualStartDate[0] || null
      this.queryParams.endActualStartDate = actualStartDate && actualStartDate[1] || null
      this.queryParams.startActualCompletionDate = actualCompletionDate && actualCompletionDate[0] || null
      this.queryParams.endActualCompletionDate = actualCompletionDate && actualCompletionDate[1] || null
      this.queryParams.startCreateBy = createByDate && createByDate[0] || null
      this.queryParams.endCreateBy = createByDate && createByDate[1] || null

      const obj = JSON.parse(JSON.stringify(this.queryParams))
      delete obj.actualStartDate
      delete obj.actualCompletionDate
      delete obj.createByDate
      this.$refs.dataTable.searchParams = obj;
      this.$refs.dataTable.getData();
    },
    // 搜索
    handleQuery () {
      this.onSearch()
    },
    // 重置
    resetQuery () {
      this.queryParams = {
        requestId: undefined,
        planName: undefined,
        planType: undefined,
        createBy: undefined,
        phaseList: undefined,
        statusList: undefined,
        actualStartDate: undefined,
        actualCompletionDate: undefined,
        createByDate: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-calendar-picker{
  width: 100% !important
}
/deep/.ant-form-item-control-wrapper{
  width: 25% !important
}
/deep/.ant-drawer-content-wrapper{
  .ant-form-item{
    .ant-form-item-control-wrapper{
      width: 83.33% !important
    }
  }
}
</style>
